
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import FileUpload from 'vue-upload-component';
import { uploadImage } from '@/api/images';

const formatSize = function(size: number): string {
  if (size > 1024 * 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB';
  } else if (size > 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB';
  } else if (size > 1024 * 1024) {
    return (size / 1024 / 1024).toFixed(2) + ' MB';
  } else if (size > 1024) {
    return (size / 1024).toFixed(2) + ' KB';
  }
  return size.toString() + ' B';
};

@Component({
  components: { FileUpload },
  filters: { formatSize },
})
export default class ImageUploadDialog extends Vue {
  $refs!: {
    upload: FileUpload;
  };

  files: VUFile[] = [];
  show: boolean = false;

  close(): void {
    this.show = false;
    this.$refs.upload.clear();
  }

  remove(file: VUFile): void {
    this.$refs.upload.remove(file);
  }

  onInput(files: VUFile[]): void {
    if (files.length > 0 && files.every(file => file.success)) {
      this.$emit('complete');
      this.close();
    }
  }

  async upload(file: VUFile): Promise<void> {
    try {
      await uploadImage(file.file);
    } catch (error: any) {
      throw new Error(error.message);
    }
  }
}
